import React from "react";
import PropTypes from "prop-types";

import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import CalendarToolbar from "./CalendarToolbar";

import "moment/locale/nl.js";

import moment from "moment";

const localizer = momentLocalizer(moment);

const messages = {
  allDay: "Hele dag",
  previous: "Vorige",
  next: "Volgende",
  today: "Vandaag",
  month: "Maand",
  week: "Week",
  day: "Dag",
  agenda: "Agenda",
  date: "Datum",
  time: "Tijd",
  event: "Evenement",
  noEventsInRange: "Geen evenementen in tijdspanne",
  //showMore: 'Toon meer',
};

const Calendar = (props) => (
  <div className="calendar-container">
    <BigCalendar
      culture={moment.locale("nl")}
      localizer={localizer}
      events={props.events}
      messages={messages}
      components={{ toolbar: CalendarToolbar }}
      showMultiDayTimes
      onSelectEvent={props.onSelectEvent}
    />
  </div>
);

Calendar.propTypes = {
  events: PropTypes.array,
  onSelectEvent: PropTypes.func,
};

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/Calendar.js